import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
// import { useTheme } from "../togglethemebar/ThemeContext";
import { addEnquiryForm ,addHelpdeskSubmission} from "../server/apihelper";

export const Header = ({
  handleApprovalClick,
}) => {
  // const { theme } = useTheme();

  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [academicDropdownOpen, setAcademicDropdownOpen] = useState(false);
  const [newsEventsDropdownOpen, setNewsEventsDropdownOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 992 : true);
const [openModal, setOpenModal] = useState(false);
 const [openHelpdeskModal, setOpenHelpdeskModal] = useState(false);

  const [helpdeskData, setHelpdeskData] = useState({
    name: "",
    department: "",
    year: "",
    email: "",
    message: "",
  });
const [formData, setFormData] = useState({
  name: "",
  email: "",
 phone: "",
  city: "",
  state: "",
  type:2,
   
});

const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await addEnquiryForm(formData);

    setOpenModal(false);

    // Directly open Brochure
    window.open(
      "https://api.mcgansarch.com/uploads/e-brounchure/McgansE-Brouchure-2026.pdf",
      "_blank"
    );

  } catch (error) {
    console.error(error);
  }
};
 const handleHelpdeskChange = (e) => {
    setHelpdeskData({ ...helpdeskData, [e.target.name]: e.target.value });
  };

  const handleHelpdeskSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await addHelpdeskSubmission(helpdeskData);
      if (response.message.includes("successfully")) {
        
        setOpenHelpdeskModal(false);
        setHelpdeskData({
          name: "",
          department: "",
          year: "",
          email: "",
          message: "",
        });
      }
    } catch (error) {
      console.error(error);
     
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setAcademicDropdownOpen(false);
    setNewsEventsDropdownOpen(false);
  };

  const toggleAcademicDropdown = () => {
    setAcademicDropdownOpen(!academicDropdownOpen);
  };

  const toggleNewsEventsDropdown = () => {
    setNewsEventsDropdownOpen(!newsEventsDropdownOpen);
  };

  return (
    <>
      {/* <div className={theme === "dark" ? "header-dark" : "header-light"}> */}
      {/* <!--Start Top Header Area--> */}

      <div className="top-header-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-4">
              {/* <div className="social-media socialmediaheader">
                <ul
                  style={{
                    display: "flex",
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <li
                    className="socialmediaheader"
                    style={{ marginRight: "10px" }}
                  >
                   
                  </li>{" "}
                  <li style={{ marginRight: "10px" }}>
                    <a
                      href="https://www.linkedin.com/in/archmcgan-ooty-2b1897304?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="McGAN'S on LinkedIn (opens in new tab)"
                    >
                      <i
                        className="ri-linkedin-fill"
                        style={{ color: "white" }}
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                  <li style={{ marginRight: "10px" }}>
                    <a
                      href="https://x.com/mcgansarch"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="McGAN'S on X (opens in new tab)"
                    >
                      <i className="ri-twitter-fill socialmediaheader" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li style={{ marginRight: "10px" }}>
                    <a
                      href="https://www.youtube.com/@mcgansooty3246"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="McGAN'S on YouTube (opens in new tab)"
                    >
                      <i className="ri-youtube-fill socialmediaheader" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li style={{ marginRight: "10px" }}>
                    <a
                      href="https://instagram.com/mcgansarch"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="McGAN'S on Instagram (opens in new tab)"
                    >
                      <i
                        className="ri-instagram-line"
                        style={{ color: "white" }}
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                  <li style={{ marginRight: "10px" }}>
                    <a
                      href="https://www.facebook.com/mcgansarch"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="McGAN'S on Facebook (opens in new tab)"
                    >
                      <i
                        className="ri-facebook-fill"
                        style={{ color: "white" }}
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                </ul>
              </div> */}
              <div className="social-media socialmediaheader">
  <ul
    style={{
      display: "flex",
      listStyle: "none",
      padding: 0,
      margin: 0,
    }}
  >
    <li className="socialmediaheader" style={{ color: "white" }}>
     Admission counselling code - <span></span>&nbsp;
<b style={{ color: "#FFD700", fontSize: "15px" }}>2759</b>
    </li>
  </ul>
</div>

            </div>

            <div className="col-lg-8 col-md-8">
              <div className="header-right-content">
                <div className="list">
                  <ul>
                    {/* <li>
                      <Link to="/alumni">Alumni</Link>
                    </li>
                    <li>
                      <Link to="/campus" className="nav-link">
                        Campus
                      </Link>
                    </li>
                    <li>
                      <Link to="/staff" className="nav-link">
                        Faculty & Staff
                      </Link>
                    </li> */}
                     <li>
  <a
    href="https://mcgansarch.com/virtual-tour/index.html"
    className="nav-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Virtual Tour
  </a>
</li>

                    <li>
                      <Link to="/careers" className="nav-link">
                        Careers
                      </Link>
                    </li>
                    <li>
                      <Link to="/student-story-details" className="nav-link">
                        Student Story
                      </Link>
                    </li>
                    {/* <li>
                      <button 
                        onClick={handleApprovalClick}
                        className="nav-link"
                        style={{
                          background: 'white',
                          border: 'none',
                          color: 'inherit',
                          cursor: 'pointer',
                          padding: '8px 12px',
                          font: 'inherit',
                          textDecoration: 'none',
                          borderRadius: '5px'
                        }}
                      >
                        Approval
                      </button>
                    </li> */}

                    <li>
                      <a href="tel:9488336599">
                        <i className="bi bi-telephone-fill"></i> &nbsp; +91 948833
                        6599
                      </a>
                    </li>
                   <li>
  <button
  className="nav-link"
  style={{
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "white",   // ⭐ ADD THIS
  }}
  onClick={() => setOpenHelpdeskModal(true)}
>
  Help Desk
</button>
</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="navbar-area nav-bg-1">
        <div className="mobile-responsive-nav">
          <div className="container">
            <div className="mobile-responsive-menu">
              <div className="logo">
                <Link to="/" className="nav-link">
                  <img
                    src="assets/images/Mcgan's-logo.svg"
                    className="main-logo"
                    title="logo"
                    alt="logo"
                    width={186}
                    height={58}
                  />
                  <img
                    src="assets/images/Mcgan's-logo.svg"
                    className="white-logo"
                    title="white-logo"
                    alt="white-logo"
                    width={186}
                    height={58}
                  />
                </Link>
              </div>
              
              {/* Hamburger Menu Button */}
              <div className="mean-bar">
                <button 
                  className="meanmenu-reveal" 
                  onClick={toggleMobileMenu}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    width: '48px',
                    height: '48px',
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                  }}
                  aria-label="Toggle mobile menu"
                >
                  <span style={{
                    display: 'block',
                    background: '#e32845',
                    height: '3px',
                    width: '22px',
                    marginBottom: '3px',
                    transition: 'all 0.3s ease'
                  }}></span>
                  <span style={{
                    display: 'block',
                    background: '#e32845',
                    height: '3px',
                    width: '22px',
                    marginBottom: '3px',
                    transition: 'all 0.3s ease'
                  }}></span>
                  <span style={{
                    display: 'block',
                    background: '#e32845',
                    height: '3px',
                    width: '22px',
                    transition: 'all 0.3s ease'
                  }}></span>
                </button>
              </div>

              {/* Mobile Navigation Menu */}
              {mobileMenuOpen && (
                <div className="mean-nav" style={{
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                  width: '100%',
                  background: '#ffffff',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                  zIndex: 999
                }}>
                  <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                    <li>
                      <Link to="/" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about-us" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        About
                      </Link>
                    </li>
                    <li>
                      <Link to="/achievements" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Achievements
                      </Link>
                    </li>
                    
                    {/* Academic Dropdown */}
                    <li>
                      <button
                        onClick={toggleAcademicDropdown}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          padding: '15px 20px',
                          borderBottom: '1px solid #efefef',
                          color: '#111111',
                          background: 'transparent',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        Academic
                        <span style={{ 
                          transform: academicDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease'
                        }}>
                          ▼
                        </span>
                      </button>
                      
                      {academicDropdownOpen && (
                        <ul style={{ 
                          listStyle: 'none', 
                          margin: 0, 
                          padding: 0,
                          backgroundColor: '#f8f8f8'
                        }}>
                          <li>
                            <Link to="/undergraduate" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              borderBottom: '1px solid #efefef',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              Undergraduate
                            </Link>
                          </li>
                          <li>
                            <Link to="/postgraduate" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              borderBottom: '1px solid #efefef',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              Postgraduate (M.Arch)
                            </Link>
                          </li>
                          <li>
                            <Link to="/march-urban" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              borderBottom: '1px solid #efefef',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              M.Arch Urban Design
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="/diploma" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              borderBottom: '1px solid #efefef',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              Diploma
                            </Link>
                          </li> */}
                          <li>
                            <Link to="/international-student" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              International Student
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>
                    <li>
                      <Link to="/gallery" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Gallery
                      </Link>
                    </li>
                                        <li>
                      <Link to="/placement " className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Placement
                      </Link>
                    </li>

                    {/* News & Events Dropdown */}
                    <li>
                      <button
                        onClick={toggleNewsEventsDropdown}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          padding: '15px 20px',
                          borderBottom: '1px solid #efefef',
                          color: '#111111',
                          background: 'transparent',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        News & Events
                        <span style={{ 
                          transform: newsEventsDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease'
                        }}>
                          ▼
                        </span>
                      </button>
                      
                      {newsEventsDropdownOpen && (
                        <ul style={{ 
                          listStyle: 'none', 
                          margin: 0, 
                          padding: 0,
                          backgroundColor: '#f8f8f8'
                        }}>
                          <li>
                            <Link to="/news" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              borderBottom: '1px solid #efefef',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              News
                            </Link>
                          </li>
                          <li>
                            <Link to="/events" className="nav-link" onClick={closeMobileMenu} style={{
                              display: 'block',
                              padding: '12px 40px',
                              color: '#111111',
                              textDecoration: 'none',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}>
                              Events
                            </Link>
                          </li>
                          
                        </ul>
                      )}
                    </li>
                    <li>
                      <Link to="/contact" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Contact
                      </Link>
                    </li>
                    <li>
                      <Link to="/campus" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Campus
                      </Link>
                    </li>
                    <li>
                      <Link to="/staff" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Faculty & Staff
                      </Link>
                    </li>
                    <li>
                      <Link to="/careers" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Careers
                      </Link>
                    </li>
                    <li>
                      <Link to="/alumni" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Alumni
                      </Link>
                    </li>
                    <li>
                      <Link to="/student-story-details" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        borderBottom: '1px solid #efefef',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Student Story
                      </Link>
                    </li>
                    <li>
                      <button 
                        onClick={() => {
                          handleApprovalClick();
                          closeMobileMenu();
                        }}
                        style={{
                          display: 'block',
                          width: '100%',
                          padding: '15px 20px',
                          borderBottom: '1px solid #efefef',
                          color: '#dad5d5',
                          background: 'transparent',
                          border: 'none',
                          textAlign: 'left',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: 'pointer'
                        }}
                      >
                        Approval
                      </button>
                    </li>
                    <li>
                      <Link to="/academic" className="nav-link" onClick={closeMobileMenu} style={{
                        display: 'block',
                        padding: '15px 20px',
                        color: '#111111',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        Apply Now
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="desktop-nav">
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light">
              <Link to="/" className="navbar-brand">
                <img
                  src="assets/images/Mcgan's-logo.svg"
                  title="Mcgan's-logo"
                  alt="Mcgan's-logo"
                  width={186}
                  height={58}
                />
              </Link>
              <div
                className="collapse navbar-collapse mean-menu"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav ms-auto">
                  <li className={`nav-item ${isActive("/") ? "active" : ""}`}>
                    <Link to="/" className="nav-link">
                      Home
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${isActive("/about-us") || isActive("/achievements")
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link to="/about-us" className="nav-link">
                      About
                    </Link>

                    <ul className="dropdown-menu">
                      <li
                        className={`nav-item ${isActive("/about-us") ? "active" : ""
                          }`}
                      >
                        <Link to="/about-us" className="nav-link">
                          About
                        </Link>
                      </li>
                      <li
                        className={`nav-item ${isActive("/achievements") ? "active" : ""
                          }`}
                      >
                        <Link to="/achievements" className="nav-link">
                          Achievements
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li
                    className={`nav-item ${isActive("/undergraduate") ||
                      isActive("/postgraduate") ||
                      isActive("/diploma") ||
                      isActive("/international-student")
                      ? "active"
                      : ""
                      }`}
                  >
                    <a href="#" className="nav-link dropdown-toggle">
                      Academic
                    </a>

                    <ul className="dropdown-menu">
                      <li
                        className={`nav-item ${isActive("/undergraduate") ? "active" : ""
                          }`}
                      >
                        <Link to="/undergraduate" className="nav-link">
                          Undergraduate
                        </Link>
                      </li>
                      <li
                        className={`nav-item ${isActive("/postgraduate") ? "active" : ""
                          }`}
                      >
                        <Link to="/postgraduate" className="nav-link">
                          Postgraduate
                        </Link>
                        <ul className="dropdown-menu">
                          <li className={`nav-item ${isActive("/march") ? "active" : ""}`}>
                            <Link to="/postgraduate" className="nav-link">
                              M.Arch Environmental Architecture
                            </Link>
                          </li>
                          <li className={`nav-item ${isActive("/march-urban") ? "active" : ""}`}>
                            <Link to="/march-urban" className="nav-link">
                              M.Arch Urban Design
                            </Link>
                          </li>
                        </ul>
                      </li>
                      {/* <li
                        className={`nav-item ${isActive("/diploma") ? "active" : ""
                          }`}
                      >
                        <Link to="/diploma" className="nav-link">
                          Diploma
                        </Link>
                      </li> */}
                      <li
                        className={`nav-item ${isActive("/international-student") ? "active" : ""
                          }`}
                      >
                        <Link to="/international-student" className="nav-link">
                          International Student
                        </Link>
                      </li>
                       <li
                        className={`nav-item ${isActive("#") ? "active" : ""
                          }`}
                           onClick={() => setOpenModal(true)}
                      >
                        <Link to="#" className="nav-link">
                          E-Brochure
                        </Link>
                      </li>
                    </ul>
                  </li>
 <li
                    className={`nav-item ${isActive("/gallery") ||
                      isActive("/postgraduate") ||
                      isActive("/diploma") ||
                      isActive("/international-student")
                      ? "active"
                      : ""
                      }`}
                  >
                    <a href="#" className="nav-link dropdown-toggle">
                      Gallery
                    </a>

                    <ul className="dropdown-menu">
                      <li
                        className={`nav-item ${isActive("/gallery") ? "active" : ""
                          }`}
                      >
                        <Link to="/gallery" className="nav-link">
                          Gallery
                        </Link>
                      </li>
                      <li
                        className={`nav-item ${isActive("/mediahub") ? "active" : ""
                          }`}
                      >
                        <Link to="/mediahub" className="nav-link">
                           McGAN’S Media Hub
                        </Link>
                      </li>
                   
                       
                    
                    
                    </ul>
                  </li>
                  {/* <li
                    className={`nav-item ${isActive("/gallery") ? "active" : ""
                      }`}
                  >
                    <Link to="/gallery " className="nav-link">
                      Gallery
                    </Link>
                    
                  </li> */}

                  <li
                    className={`nav-item ${isActive("/placement") ? "active" : ""
                      }`}
                  >
                    <Link to="/placement " className="nav-link">
                      Placement
                    </Link>
                  </li>

                  <li
                    className={`nav-item ${isActive("/news") || isActive("/events") ? "active" : ""
                      }`}
                  >
                    {/* dropdown-toggle */}
                    <a href="/news" className="nav-link ">
                      News & Events
                    </a>

                    {/* <ul className="dropdown-menu">
                      <li
                        className={`nav-item ${isActive("/news") ? "active" : ""
                          }`}
                      >
                        <Link to="/news" className="nav-link">
                          News
                        </Link>
                      </li>
                      <li
                        className={`nav-item ${isActive("/events") ? "active" : ""
                          }`}
                      >
                        <Link to="/events" className="nav-link">
                          Events
                        </Link>
                      </li>
                       <li
                        className={`nav-item ${isActive("/blogs") ? "active" : ""
                          }`}
                      >
                        <Link to="/blogs" className="nav-link">
                          Blogs
                        </Link>
                      </li>
                    </ul> */}
                  </li>

                  <li
                    className={`nav-item ${isActive("/contact") ? "active" : ""
                      }`}
                  >
                    <Link to="/contact" className="nav-link">
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link to="/academic" className="nav-link">
                      <button
                        type="button"
                        className="default-btn btn btnfamily apply-now-header-btn"

                      >
                        Apply Now
                      </button>
                    </Link>

                  </li>
                </ul>

                {isDesktop && (
                  <div className="others-options">
                    <div className="icon">
                      <i
                        className="ri-menu-3-fill"
                        data-bs-toggle="modal"
                        data-bs-target="#sidebarModal"
                      ></i>
                    </div>
                  </div>
                )}
              </div>
            </nav>
          </div>
        </div>

        {/* Hide sidebar modal trigger in mobile view */}
        {isDesktop && (
          <div className="others-option-for-responsive">
            <div className="container">
              <div className="dot-menu">
                <div className="inner">
                  <div className="icon">
                    <i
                      className="ri-menu-3-fill"
                      data-bs-toggle="modal"
                      data-bs-target="#sidebarModal"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* <!-- End Navbar Area --> */}

      {/* <!-- Sidebar Modal (desktop only) --> */}
      {isDesktop && (
        <div
          className="sidebarModal modal right fade"
          id="sidebarModal"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button type="button" className="close" data-bs-dismiss="modal">
                <i className="ri-close-line"></i>
              </button>

              <div className="modal-body">
                <a>
                  <img
                    src="assets/images/Mcgan's-logo.svg"
                    width="186px"
                    height="58px"
                    className="main-logo"
                    title="main-logo"
                    alt="main-logo"
                  />
                </a>
                <div className="sidebar-content">
                  <h3>About Us</h3>
                  <p>
                    McGAN'S Ooty School of Architecture aims to inspire socially
                    responsible leaders through a progressive, interdisciplinary
                    curriculum that nurtures creativity, critical thinking, and
                    community engagement in a breathtaking environment.
                  </p>

                  <div className="sidebar-btn">
                    <Link to="/about-us" className="nav-link">
                      <button type="button" className="default-btn btn btnfamily">
                        About Us
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="sidebar-contact-info">
                  <h3>Contact Information</h3>

                  <ul className="info-list">
                    <li>
                      <i className="ri-phone-fill"></i>{" "}
                      <a href="tel:9488336599">+91 94883 36599</a>
                    </li>

                    <li>
                      <i className="ri-mail-line"></i>
                      <a href="mailto:mcgansoffice@gmail.com">
                        mcgansoffice@gmail.com
                      </a>
                    </li>

                    <li>
                      <i className="ri-map-pin-line"></i>McGAN'S Ooty School of
                      Architecture Perar, Kotagiri Road, Ooty, The Nilgiris,
                      Tamilnadu - 643002
                    </li>
                  </ul>
                </div>
                <ul className="sidebar-social-list">
                  <li>
                    <a href="https://www.facebook.com/McGansArch" target="_blank">
                      <i className="flaticon-facebook"></i>
                      <span className="visually-hidden">Facebook</span>
                    </a>
                  </li>
                  <li>
                    <a
                        href="https://www.youtube.com/@mcgansooty3246"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="McGAN'S on YouTube (opens in new tab)"
                      >
                        <i className="flaticon-youtube" aria-hidden="true"></i>
                        <span className="visually-hidden">YouTube</span>
                      </a>
                  </li>
                  <li>
                    <a href="https://linkedin.com/company/mcgansarch" target="_blank">
                      <i className="flaticon-linkedin"></i>
                      <span className="visually-hidden">LinkedIn</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://instagram.com/?lang=en" target="_blank">
                      <i className="flaticon-instagram"></i>
                      <span className="visually-hidden">Instagram</span>
                    </a>
                  </li>
                </ul>
                <div className="contact-form">
                  <h3>Ready to Get Started?</h3>

                  <form id="contactForm">
                    <div className="row">
                      <div className="col-lg-12 col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            required
                            data-error="Please enter your name"
                            placeholder="Your name"
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            required
                            data-error="Please enter your email"
                            placeholder="Your email address"
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="phone_number"
                            className="form-control"
                            required
                            data-error="Please enter your phone number"
                            placeholder="Your phone number"
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            className="form-control"
                            cols="30"
                            rows="6"
                            required
                            data-error="Please enter your message"
                            placeholder="Write your message..."
                          ></textarea>
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <button type="submit" className="default-btn">
                          Send Message<span></span>
                        </button>
                        <div
                          id="msgSubmit"
                          className="h3 text-center hidden"
                        ></div>
                        <div className="clearfix"></div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openModal && (
  <div className="ebrochure_overlay">
    <div className="ebrochure_modal">
      <h3>Download E-Brochure</h3>

      <form onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder="Name" required 
          value={formData.name} onChange={handleChange} />

        <input type="email" name="email" placeholder="Email ID" required 
          value={formData.email} onChange={handleChange} />

        <input type="text" name="phone" placeholder="WhatsApp Number" required 
          value={formData.phone} onChange={handleChange} />

        <input type="text" name="city" placeholder="Residence Place" required 
          value={formData.city} onChange={handleChange} />

        <input type="text" name="state" placeholder="State" required 
          value={formData.state} onChange={handleChange} />

        <div className="modal_btn_grp">
          <button type="submit" className="submit_btn">Submit</button>
          <button type="button" className="cancel_btn" onClick={() => setOpenModal(false)}>Cancel</button>
        </div>
      </form>
    </div>
  </div>
)}
{openHelpdeskModal && (
  <div className="ebrochure_overlay">
    <div className="ebrochure_modal">
      <h3>Help Desk</h3>

      <form onSubmit={handleHelpdeskSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Name"
          required
          value={helpdeskData.name}
          onChange={handleHelpdeskChange}
        />

        <input
          type="text"
          name="department"
          placeholder="Department"
          required
          value={helpdeskData.department}
          onChange={handleHelpdeskChange}
        />

        <input
          type="text"
          name="year"
          placeholder="Year"
          required
          value={helpdeskData.year}
          onChange={handleHelpdeskChange}
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          required
          value={helpdeskData.email}
          onChange={handleHelpdeskChange}
        />

        <textarea
          name="message"
          placeholder="Message"
          required
          value={helpdeskData.message}
          onChange={handleHelpdeskChange}
        />

        <div className="modal_btn_grp">
          <button type="submit" className="submit_btn">
            Submit
          </button>

          <button
            type="button"
            className="cancel_btn"
            onClick={() => setOpenHelpdeskModal(false)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
)}
      {/* <!-- End Sidebar Modal --> */}
      {/* Approval modal is now rendered globally in App.js */}
    </>
  );
};
